// extracted by mini-css-extract-plugin
export default {"wrapper":"Hamburger_wrapper__rbca1","container":"Hamburger_container__c92GI","list":"Hamburger_list__oioQV","products":"Hamburger_products__ZH6j9"};